import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import instance from 'src/app/axiosInterceptor';

// GET list service package prices (filter by owner)
export const getServicePackagePrices = createAsyncThunk(
  'servicePackagePriceSlice/getServicePackagePrices',
  async (params, { rejectWithValue }) => {
    try {
      const query = new URLSearchParams(params).toString();
      const res = await instance.get(`/service_package_price?${query}`);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// POST create service package price
export const createServicePackagePrice = createAsyncThunk(
  'servicePackagePriceSlice/createServicePackagePrice',
  async (data, { rejectWithValue }) => {
    try {
      const res = await instance.post('/service_package_price', data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// PUT update service package price
export const updateServicePackagePrice = createAsyncThunk(
  'servicePackagePriceSlice/updateServicePackagePrice',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await instance.put(`/service_package_price/${id}`, data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// DELETE service package price(s)
export const deleteServicePackagePrices = createAsyncThunk(
  'servicePackagePriceSlice/deleteServicePackagePrices',
  async (list_id, { rejectWithValue }) => {
    try {
      const res = await instance.delete('/service_package_price', {
        data: { list_id }
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const servicePackagePriceSlice = createSlice({
  name: 'servicePackagePriceSlice',
  initialState: {
    listServicePackagePrices: [],
    loading: false,
    error: null,
    total: 0
  },
  reducers: {},
  extraReducers: {
    [getServicePackagePrices.pending]: state => {
      state.loading = true;
      state.error = null;
    },
    [getServicePackagePrices.fulfilled]: (state, action) => {
      state.loading = false;
      state.listServicePackagePrices =
        action.payload?.payload?.result ||
        action.payload?.payload?.data ||
        action.payload?.payload?.service_package_prices ||
        action.payload?.payload?.servicePackagePrices ||
        [];
      state.total =
        action.payload?.payload?.numberOfItem ??
        action.payload?.payload?.number_of_item ??
        action.payload?.payload?.total ??
        0;
    },
    [getServicePackagePrices.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    [createServicePackagePrice.fulfilled]: state => {
      state.loading = false;
    },
    [updateServicePackagePrice.fulfilled]: state => {
      state.loading = false;
    },
    [deleteServicePackagePrices.fulfilled]: state => {
      state.loading = false;
    }
  }
});

export default servicePackagePriceSlice.reducer;
